<div class="scenario-card lineout">
	<div class="scenario-card-icon-container">
		<img class="pointer" data-ref="icon">
	</div>
	<div class="list grow">
		<div class="row-compact">
			<h6 class="pointer" data-ref="title"></h6>
			<button class="strip ghost pointer" data-ref="download">⤓</button>
			<button class="strip ghost pointer" data-ref="delete">✖</button>
			<button class="strip ghost pointer" data-ref="edit">✎</button>
			<button class="lineout" data-ref="play">play</button>
		</div>
		<div class="row baseline">
			<a data-ref="author-link" hidden></a>
			<span data-ref="author" hidden></span>
			<div class="hint float-end" data-ref="tokens"></div>
		</div>
		<hr>
		<div class="scenario-card-description md" data-ref="description"></div>
		<div class="scenario-card-tags" data-ref="tags"></div>
	</div>
</div>
